import { DetailedHTMLProps, FC, HTMLAttributes } from 'react';

export const ZeroWidthSpace: FC<DetailedHTMLProps<HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>> = ({ ...props }) => <span {...props}>&#8203;</span>;
